import React, { Fragment } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import Map from '../components/Map/Map';
import SEO from '../components/SEO/SEO';

type LocationProps = {}

const Location:React.FC<LocationProps> = (props: LocationProps) => {
  return (
    <Fragment>
      <SEO 
        title="Grupo GM | Ubicación"
        description="Encuentra la ubicación de Grupo GM en Hidalgo. Visítanos para conocer nuestros servicios de renta de cajas secas y plataformas."
        canonicalUrl="https://grupo-gm.mx/ubicacion"
      />
      <Navbar fixedScrolled={true}/>
      <Map />
      <Footer />
    </Fragment>
  )
}

export default Location;